import React, { useState } from 'react';
import './common.css';
import { NavLink, useLocation } from 'react-router-dom';
import footer_logo from '../../assets/images/footer_logo.svg';
import dc_fotr_icon1 from '../../assets/images/dc_fotr_icon1.svg';
import dc_fotr_icon2 from '../../assets/images/dc_fotr_icon2.svg';
import BestOfferModal from './BestOfferModal';
import { LOAN_TYPE } from '../credit-report/constants';
import {
  ABOUT_US_PAGE_ROUTE,
  BUSINESS_LOAN_PAGE_ROUTE,
  CONTACT_US_PAGE_ROUTE,
  GRIEVANCE_REDRESSAL_PAGE_ROUTE,
  PERSONAL_LOAN_PAGE_ROUTE,
  PRIVACY_POLICY_PAGE_ROUTE,
  TERMS_N_COND_PAGE_ROUTE,
  THANK_YOU_PAGE_ROUTE,
} from '../../data/routes-constants';

const FooterTest = ({ scrolledUp = false }) => {
  const [isModalOpen, setIsModalopen] = useState(false);
  const [loanType, setLoanType] = useState('');
  const location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleRedirection = (e, type) => {
    e.preventDefault();
    setIsModalopen(true);
    setLoanType(type);
  };

  return (
    <div>
      {location.pathname !== THANK_YOU_PAGE_ROUTE && (
        <div className={`get_best_offer_fix ${scrolledUp ? 'hidden' : ''}`}>
          {' '}
          <NavLink
            to="/"
            className={'sm:tw-rounded-[6px]'}
            onClick={(e) => {
              e.preventDefault();
              setIsModalopen(true);
            }}>
            Get Best Offers
          </NavLink>
        </div>
      )}
      <footer>
        <div className="footer_top">
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <div className="fotr_logo">
                  <NavLink to="/" onClick={scrollToTop}>
                    {' '}
                    <img src={footer_logo} alt="Logo" />
                  </NavLink>
                </div>
              </div>
              <div className="col-md-4">
                <div className="fotr_links">
                  <h4 className="lg:tw-text-[18px] tw-pointer-events-none tw-select-none">
                    OUR SERVICES
                  </h4>
                  <ul>
                    <li>
                      <NavLink
                        to={PERSONAL_LOAN_PAGE_ROUTE}
                        onClick={scrollToTop}>
                        Personal Loan
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={BUSINESS_LOAN_PAGE_ROUTE}
                        onClick={scrollToTop}>
                        Business Loan
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        onClick={(e) =>
                          handleRedirection(e, LOAN_TYPE.homeLoan)
                        }>
                        Home Loan
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        onClick={(e) =>
                          handleRedirection(e, LOAN_TYPE.creditCard)
                        }>
                        Credit Cards
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        onClick={(e) =>
                          handleRedirection(e, LOAN_TYPE.loanAgainstProperty)
                        }>
                        Loan Against Property
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-4">
                <div className="fotr_links">
                  <h4 className="lg:tw-text-[18px] tw-pointer-events-none tw-select-none">
                    CONTACT US
                  </h4>

                  <div className="fotr_contctinfos tw-pointer-events-none tw-select-none">
                    <span className="sm:tw-mt-[6px]">
                      <img
                        className="tw-max-w-fit"
                        src={dc_fotr_icon1}
                        alt="Icon"
                      />
                    </span>
                    DotPe Private Limited, Tower D, Floor 8, Unitech Cyberpark,
                    Sector 39, Gurgaon, Haryana 122003
                  </div>
                  <div className="fotr_contctinfos">
                    <span className="sm:tw-mt-[6px]">
                      <img src={dc_fotr_icon2} alt="Icon" />
                    </span>
                    <a
                      href="mailto:customer.support@dotpe.in"
                      className="f_mail">
                      customer.support@dotpe.in
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer_mid">
          <div className="container_full">
            <div className="fotr_midlink">
              <NavLink to={ABOUT_US_PAGE_ROUTE} onClick={scrollToTop}>
                About Us
              </NavLink>
              <NavLink to={CONTACT_US_PAGE_ROUTE}>Contact Us</NavLink>
              <NavLink to={PRIVACY_POLICY_PAGE_ROUTE} onClick={scrollToTop}>
                Privacy Policy
              </NavLink>
              <NavLink to={TERMS_N_COND_PAGE_ROUTE} onClick={scrollToTop}>
                Terms of Use
              </NavLink>
              <NavLink
                to={GRIEVANCE_REDRESSAL_PAGE_ROUTE}
                onClick={scrollToTop}>
                Grievance Redressal
              </NavLink>
              <NavLink
                to="https://sachet.rbi.org.in/"
                target="_blank"
                onClick={scrollToTop}>
                RBI Sachet
              </NavLink>
              <NavLink to={TERMS_N_COND_PAGE_ROUTE} onClick={scrollToTop}>
                Important Links
              </NavLink>
            </div>
          </div>
        </div>

        <div className="footer_bottom">
          <div className="container">
            <div className="footer_bottom_infos">
              <div className="row">
                <div className="col-md-4">
                  <div className="fotr_cinnmbr tw-pointer-events-none tw-select-none">
                    <span>CIN No.</span> U72200HR2019PTC080437
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="fotr_copytext">
                    <p>
                      <span className="tw-pointer-events-none tw-select-none">
                        © 2025 DotPe Pvt Ltd.{' '}
                      </span>
                      <br className="tw-hidden sm:tw-block" />
                      <span className="tw-pointer-events-none tw-select-none">
                        All Rights Reserved.
                      </span>
                    </p>
                    <h6 className="tw-pointer-events-none tw-select-none">
                      Made with love in India
                    </h6>
                  </div>
                </div>
                <div className="col-md-4"></div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {isModalOpen && (
        <BestOfferModal
          isModalOpen={isModalOpen}
          setIsModalopen={setIsModalopen}
          loanType={loanType}
        />
      )}
    </div>
  );
};

export default FooterTest;
